import { api } from '@/api/axiosInstance';
import { ApiResponseType, R2GATE_MODULE_TYPE } from '@/api/type/commonTypes';

interface postCreateLicenseKeysProps {
  module: R2GATE_MODULE_TYPE;
  count: number; // 1~10;
  reason: string;
}

interface PostCreateLicenseKeysResponse {
  licenseKeyIds: string[];
}

/** 라이선스 키 발급 */
export const postCreateLicenseKeys = async ({
  module,
  count,
  reason,
}: postCreateLicenseKeysProps) => {
  const res = await api.post<ApiResponseType<PostCreateLicenseKeysResponse>>(
    `/api/web/admins/license-keys/${module}`,
    {
      count,
      reason,
    }
  );
  return res.data;
};
